import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, ModalBody } from 'reactstrap';
import { Loader } from './../../../components/loader';
import { fetchReseted } from '../actions/postReseted';

class Reseted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            password_confirmation: '',
        };
        this.confirmAction = this.confirmAction.bind(this);
        this.modalLine = this.modalLine.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }

    confirmAction() {
        let state = this.state;
        let props = this.props;
        const { dispatch } = props;
        let data = {
            token: props.token,
            email: state.email,
            password: state.password,
            password_confirmation: state.password_confirmation,
        };
        dispatch(fetchReseted(data, props.onValid));
    }

    modalLine(content) {
        return <div className="modal-line mt-4">{content()}</div>;
    }

    changeInput(event) {
        let id = event.target.id;
        let state = {};
        state[id] = event.target.value;
        this.setState({ ...state });
    }

    render() {
        let props = this.props;
        let state = this.state;
        let isFetching = props.isFetching;
        return (
            <div>
                <div className="modal-scroll">
                    {isFetching ? <Loader /> : null}
                    <ModalBody>
                        {this.modalLine(() => (
                            <Input
                                value={state.email}
                                id={'email'}
                                placeholder="Email"
                                onChange={this.changeInput}
                            />
                        ))}
                        {this.modalLine(() => (
                            <Input
                                type="password"
                                id={'password'}
                                placeholder="Новый пароль"
                                value={state.password}
                                onChange={this.changeInput}
                            />
                        ))}
                        {this.modalLine(() => (
                            <Input
                                type="password"
                                id={'password_confirmation'}
                                placeholder="Подтвердите пароль"
                                value={state.password_confirmation}
                                onChange={this.changeInput}
                            />
                        ))}
                        <div className="submit-button-container mt-4">
                            <div
                                className="submit-button mt-2 pointer-no-select"
                                onClick={this.confirmAction}
                            >
                                Сохранить
                            </div>
                        </div>
                    </ModalBody>
                </div>
            </div>
        );
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        isFetching: state.authState.reseted.isFetching,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
};

export const ResetedLink = connect(
    MapStateToProps,
    mapDispatchToProps
)(Reseted);
